// Subject string constants
export const ENGLISH_LANGUAGE_ARTS = 'English Language Arts';
export const MATH = 'Math';
export const SCIENCE = 'Science';
export const SOCIAL_STUDIES = 'Social Studies';
export const WORLD_LANGUAGE = 'World Language';
export const CAREER_AND_TECHNICAL_EDUCATION = 'Career and Technical Education';
export const SPECIAL_EDUCATION = 'Special Education';
export const ARTS = 'Arts';
export const OTHER = 'Other';
export const HEALTH = 'Health';

export const SUBJECT_MAP = {
  ENGLISH_LANGUAGE_ARTS,
  MATH,
  SCIENCE,
  SOCIAL_STUDIES,
  WORLD_LANGUAGE,
  CAREER_AND_TECHNICAL_EDUCATION,
  SPECIAL_EDUCATION,
  ARTS,
  OTHER,
  HEALTH,
};

export const SUBJECTS = [
  { title: 'English Language Arts', server_value: ENGLISH_LANGUAGE_ARTS },
  { title: 'Social Studies', server_value: SOCIAL_STUDIES },
  { title: 'Science', server_value: SCIENCE },
  { title: 'Math', server_value: MATH },
  { title: 'Special Education', server_value: SPECIAL_EDUCATION },
  { title: 'Career & Technical Education', server_value: CAREER_AND_TECHNICAL_EDUCATION },
  { title: 'World Language', server_value: WORLD_LANGUAGE },
  { title: 'Arts', server_value: ARTS },
  { title: 'Health', server_value: HEALTH },
  { title: 'Something Else', server_value: OTHER },
];

export const ROLES = [
  { title: 'Classroom Teacher', server_value: 'classroom_teacher' },
  { title: 'Intervention Specialist', server_value: 'intervention_specialist' },
  {
    title: 'Support Staff',
    subtitle: '(e.g., librarian, counselor)',
    server_value: 'support_staff',
  },
  { title: 'Instructional Coach', server_value: 'instructional_coach' },
  { title: 'School Leader', server_value: 'school_leader' },
  { title: 'District Leader', server_value: 'district_leader' },
  { title: 'Something Else', server_value: 'other' },
];

export const INTERVENTION_SPECIALIST_TYPES = [
  { title: 'Multilingual Learners', server_value: 'intervention_specialist_multilingual_learners' },
  { title: 'Students with IEPs', server_value: 'intervention_specialist_students_with_ieps' },
  { title: 'Gifted & Talented', server_value: 'intervention_specialist_gifted_and_talented' },
  { title: 'Other', server_value: 'intervention_specialist_other' },
];

export const CLASS_OPTIONS = [
  {
    name: 'All core subjects',
    server_value: 'all_core_subjects',
    subjects: [ENGLISH_LANGUAGE_ARTS, MATH, SCIENCE, SOCIAL_STUDIES],
  },
  {
    name: 'Agriculture / FFA',
    server_value: 'agriculture_ffa',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  { name: 'Algebra 1', server_value: 'algebra_1', subjects: [MATH] },
  { name: 'Algebra 2', server_value: 'algebra_2', subjects: [MATH] },
  {
    name: 'American Sign Language (ASL)',
    server_value: 'american_sign_language',
    subjects: [WORLD_LANGUAGE],
  },
  { name: 'Anatomy & Physiology', server_value: 'anatomy_physiology', subjects: [SCIENCE] },
  { name: 'AP Biology', server_value: 'ap_biology', subjects: [SCIENCE] },
  { name: 'AP Calculus AB', server_value: 'ap_calculus_ab', subjects: [MATH] },
  { name: 'AP Calculus BC', server_value: 'ap_calculus_bc', subjects: [MATH] },
  { name: 'AP Chemistry', server_value: 'ap_chemistry', subjects: [SCIENCE] },
  {
    name: 'AP English Language and Composition',
    server_value: 'ap_english_language_and_composition',
    subjects: [ENGLISH_LANGUAGE_ARTS],
  },
  {
    name: 'AP English Literature and Composition',
    server_value: 'ap_english_literature_and_composition',
    subjects: [ENGLISH_LANGUAGE_ARTS],
  },
  {
    name: 'AP Environmental Science',
    server_value: 'ap_environmental_science',
    subjects: [SCIENCE],
  },
  {
    name: 'AP United States Government & Politics',
    server_value: 'ap_us_government_politics',
    subjects: [SOCIAL_STUDIES],
  },
  { name: 'AP Human Geography', server_value: 'ap_human_geography', subjects: [SOCIAL_STUDIES] },
  { name: 'AP Literature', server_value: 'ap_literature', subjects: [ENGLISH_LANGUAGE_ARTS] },
  { name: 'AP Physics', server_value: 'ap_physics', subjects: [SCIENCE] },
  { name: 'AP Psychology', server_value: 'ap_psychology', subjects: [SOCIAL_STUDIES] },
  { name: 'AP Statistics', server_value: 'ap_statistics', subjects: [MATH] },
  { name: 'AP U.S. History', server_value: 'ap_us_history', subjects: [SOCIAL_STUDIES] },
  { name: 'AP World History', server_value: 'ap_world_history', subjects: [SOCIAL_STUDIES] },
  {
    name: 'Automotive Technology',
    server_value: 'automotive_technology',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  {
    name: 'Business / Entrepreneurship',
    server_value: 'business_entrepreneurship',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  { name: 'Calculus', server_value: 'calculus', subjects: [MATH] },
  { name: 'Chemistry', server_value: 'chemistry', subjects: [SCIENCE] },
  { name: 'Civics / Government', server_value: 'civics_government', subjects: [SOCIAL_STUDIES] },
  {
    name: 'Coding / Programming',
    server_value: 'coding_programming',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  {
    name: 'Computer Science',
    server_value: 'computer_science',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  {
    name: 'Construction / Woodshop',
    server_value: 'construction_woodshop',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  { name: 'Creative Writing', server_value: 'creative_writing', subjects: [ENGLISH_LANGUAGE_ARTS] },
  {
    name: 'Culinary Arts',
    server_value: 'culinary_arts',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  { name: 'Dance', server_value: 'dance', subjects: [ARTS] },
  {
    name: 'Digital Art / Graphic Design',
    server_value: 'digital_art_graphic_design',
    subjects: [ARTS],
  },
  { name: 'Earth & Physical Science', server_value: 'earth_physical_science', subjects: [SCIENCE] },
  { name: 'Economics', server_value: 'economics', subjects: [SOCIAL_STUDIES] },
  { name: 'Engineering', server_value: 'engineering', subjects: [CAREER_AND_TECHNICAL_EDUCATION] },
  { name: 'English Language Arts', server_value: 'ela', subjects: [ENGLISH_LANGUAGE_ARTS] },
  { name: 'Environmental Science', server_value: 'environmental_science', subjects: [SCIENCE] },
  {
    name: 'Family & Consumer Science',
    server_value: 'family_consumer_science',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  {
    name: 'Financial Literacy',
    server_value: 'financial_literacy',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  { name: 'French', server_value: 'french', subjects: [WORLD_LANGUAGE] },
  { name: 'Geography', server_value: 'geography', subjects: [SOCIAL_STUDIES] },
  { name: 'Geometry', server_value: 'geometry', subjects: [MATH] },
  { name: 'German', server_value: 'german', subjects: [WORLD_LANGUAGE] },
  { name: 'Health', server_value: 'health', subjects: [SCIENCE] },
  {
    name: 'Journalism / Yearbook',
    server_value: 'journalism_yearbook',
    subjects: [ENGLISH_LANGUAGE_ARTS],
  },
  { name: 'Latin', server_value: 'latin', subjects: [WORLD_LANGUAGE] },
  { name: 'Life Science & Biology', server_value: 'life_science_biology', subjects: [SCIENCE] },
  { name: 'Life Skills', server_value: 'life_skills', subjects: [CAREER_AND_TECHNICAL_EDUCATION] },
  { name: 'Mandarin Chinese', server_value: 'mandarin_chinese', subjects: [WORLD_LANGUAGE] },
  { name: 'Marketing', server_value: 'marketing', subjects: [CAREER_AND_TECHNICAL_EDUCATION] },
  { name: 'Math', server_value: 'math', subjects: [MATH] },
  { name: 'Music', server_value: 'music', subjects: [ARTS] },
  {
    name: 'Personal Fitness & Nutrition',
    server_value: 'personal_fitness_nutrition',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  { name: 'Physical Education (PE)', server_value: 'physical_education', subjects: [HEALTH] },
  { name: 'Physics', server_value: 'physics', subjects: [SCIENCE] },
  { name: 'Pre-Algebra', server_value: 'pre_algebra', subjects: [MATH] },
  {
    name: 'Pre-Calculus / Trigonometry',
    server_value: 'pre_calculus_trigonometry',
    subjects: [MATH],
  },
  { name: 'Psychology', server_value: 'psychology', subjects: [SOCIAL_STUDIES] },
  {
    name: 'Reading / Literacy',
    server_value: 'reading_literacy',
    subjects: [ENGLISH_LANGUAGE_ARTS],
  },
  {
    name: 'Reading Intervention',
    server_value: 'reading_intervention',
    subjects: [ENGLISH_LANGUAGE_ARTS],
  },
  { name: 'Robotics', server_value: 'robotics', subjects: [CAREER_AND_TECHNICAL_EDUCATION] },
  { name: 'Science', server_value: 'science', subjects: [SCIENCE] },
  { name: 'Social Studies', server_value: 'social_studies', subjects: [SOCIAL_STUDIES] },
  { name: 'Sociology', server_value: 'sociology', subjects: [SOCIAL_STUDIES] },
  {
    name: 'Sociology & Psychology',
    server_value: 'sociology_psychology',
    subjects: [SOCIAL_STUDIES],
  },
  { name: 'Spanish', server_value: 'spanish', subjects: [WORLD_LANGUAGE] },
  { name: 'Speech & Debate', server_value: 'speech_debate', subjects: [ENGLISH_LANGUAGE_ARTS] },
  { name: 'Statistics', server_value: 'statistics', subjects: [MATH] },
  { name: 'STEM / STEAM', server_value: 'stem_steam', subjects: [CAREER_AND_TECHNICAL_EDUCATION] },
  { name: 'Theater / Drama', server_value: 'theater_drama', subjects: [ARTS] },
  { name: 'U.S. History', server_value: 'us_history', subjects: [SOCIAL_STUDIES] },
  { name: 'Visual Arts', server_value: 'visual_arts', subjects: [ARTS] },
  {
    name: 'Web / Game Design',
    server_value: 'web_game_design',
    subjects: [CAREER_AND_TECHNICAL_EDUCATION],
  },
  { name: 'World History', server_value: 'world_history', subjects: [SOCIAL_STUDIES] },
];

// Grade band boundaries for mapping individual grade levels to bands
export const GRADE_BAND_MAP = {
  K: 'K-2',
  1: 'K-2',
  2: 'K-2',
  3: '3-5',
  4: '3-5',
  5: '3-5',
  6: '6-8',
  7: '6-8',
  8: '6-8',
  9: '9-12',
  10: '9-12',
  11: '9-12',
  12: '9-12',
};

export const GRADE_BANDS = ['K-2', '3-5', '6-8', '9-12'];
